@if (platform === "android") {
  <div id="mobile-system-bar-background"></div>
}
<div
  id="AppContainer"
  [class]="platform"
  [class.nav-margin]="env.navMargin"
  [class.mobile-nav-margin]="env.mobileNavMargin"
>
  <app-menu></app-menu>
  <router-outlet (activate)="showSpinner()"></router-outlet>
  @if (isMobile) {
    <app-mobile-nav></app-mobile-nav>
  }
  <app-footer></app-footer>
  <app-spinner></app-spinner>
  @if (env.enableChatbot) {
    <app-chat-bot></app-chat-bot>
  }
</div>
@if (platform === "android") {
  <div id="mobile-system-bar-background-footer"></div>
}
